import React from "react";
import { Card } from "react-bootstrap";

const Messages = ({ messages }) => {
  return (
    <>
      <h2 className="text-center">Messages</h2>

      <div className="container-fluid d-flex justify-content-center align-items-center flex-wrap">
        {messages.map((msg) => {
          return (
            <Card className="m-2" style={{ width: "18rem" }}>
              <Card.Body>
                <Card.Title>{msg?.name}</Card.Title>
                <Card.Text>Email: {msg?.email}</Card.Text>
                <Card.Text>{msg?.message}</Card.Text>
              </Card.Body>
            </Card>
          );
        })}
      </div>
    </>
  );
};

export default Messages;
